import React, { useEffect, useState } from 'react';
import { Field } from 'formik';

import client from 'bv360/utils/api-client';
import RadioGroupField from 'shared/components/form/fields/radio-group';

// EXODAR-1852: the SMS option is off (QUICK_SIGN_SMS_ENABLED) until the Twilio
// A2P 10DLC campaign is approved. The consent text below is the campaign's
// registered call to action -- keep it in sync with the Twilio registration and
// /sms-terms/ if it changes.

export const VERIFY_METHODS = [
  { label: 'Text message (SMS)', value: 'sms' },
  { label: 'Email', value: 'email' }
];

export const useQuickSignSmsEnabled = () => {
  const [smsEnabled, setSmsEnabled] = useState(false);

  useEffect(() => {
    let active = true;
    client
      .get('exogen-rx/api/documents/quick-sign-config')
      .then(({ body }) => active && setSmsEnabled(!!body?.smsEnabled))
      .catch(() => active && setSmsEnabled(false));
    return () => {
      active = false;
    };
  }, []);

  return smsEnabled;
};

export const SmsConsentText = () => (
  <p data-testid="sms-consent" style={{ fontStyle: 'italic', fontSize: '0.9em' }}>
    By selecting Text message (SMS) and clicking Submit, you agree to receive a one-time
    verification code by text message from Bioventus (EXOGEN Portal) at the mobile number provided.
    One message per request. Consent is not a condition of purchase; you may choose Email instead.
    Msg &amp; data rates may apply. Reply HELP for help, STOP to opt out. See our{' '}
    <a href="/sms-terms/" target="_blank" rel="noopener noreferrer">
      SMS Terms
    </a>{' '}
    and{' '}
    <a href="/privacy-policy/" target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </a>
    .
  </p>
);

export const VerifyMethodField = ({ disabled }) => (
  <Field
    label="Send my verification code by*"
    name="verifyMethod"
    disabled={disabled}
    component={RadioGroupField}
    elems={VERIFY_METHODS}
  />
);
